<template>
    <div class="relative">
        <BaseButton
            class="text-theme-toolbar-icon"
            data-action="dictionary"
            :disabled="isOffline"
            :btn-text="btnText"
            :tooltip="localizations[lang].tooltips.dictionary"
            icon="dictionary_24px"
            @click="handleClick()"
        />
        <transition name="slide-fade">
            <ComponentTooltip v-show="showTooltipWarn" :allow-wrap="true">
                <div class="w-full text-center" style="white-space: pre-line">{{ errorMessage }}</div>
            </ComponentTooltip>
        </transition>
    </div>
</template>
<script>
import ComponentTooltip from '_shared_/UI/Components/ComponentTooltip.vue';
import { mapState } from 'vuex';
import BaseButton from '../../Components/buttons/BaseButton.vue';
import { DICTIONARY_MAX_WORDS, TOOLTIP_AUTO_HIDE_DURATION } from '_shared_/js/constants/readerSelectionToolLimits.js';

export default {
    components: {
        ComponentTooltip,
        BaseButton,
    },
    props: {
        text: {
            type: String,
            required: true,
        },
        isDesktop: {
            type: Boolean,
            required: true,
        },
        openToast: {
            type: Function,
            required: true,
        },
        withText: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    emits: ['dictionary'],
    data() {
        return {
            showTooltipWarn: false,
            maxWords: DICTIONARY_MAX_WORDS,
        };
    },
    computed: {
        ...mapState(['localizations', 'lang', 'isOffline']),
        btnText() {
            return this.withText ? this.localizations[this.lang].tooltips.dictionary : null;
        },
        isValid() {
            const wordCount = this.text?.split(' ')?.length || 0;
            return wordCount <= this.maxWords;
        },
        wordCount() {
            return this.text?.split(' ')?.length || 0;
        },
        errorMessage() {
            return this.localizations[this.lang].dictionaryValidation.message
                .replace('{count}', this.wordCount)
                .replace(/{max}/g, this.maxWords);
        },
    },
    methods: {
        handleClick() {
            if (!this.isValid) {
                if (!this.showTooltipWarn && this.isDesktop) {
                    this.showTooltipWarn = true;
                    setTimeout(() => (this.showTooltipWarn = false), TOOLTIP_AUTO_HIDE_DURATION);
                } else if (!this.isDesktop) {
                    this.openToast({ text: this.errorMessage });
                }
                return;
            }
            this.$emit('dictionary', this.text);
        },
    },
};
</script>
